export default {
  viewBox: "0 0 24 24",
  html: "<path fill-rule=\"evenodd\" d=\"M19 4a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2zM5 12h6V8H5zm8 0h6V8h-6zm-8 6h6v-4H5zm8-4v4h6v-4z\"/>"
};